export default __webpack_public_path__ + "static/lsa-491cad2752ab329e72245055b16b4371.mp4";